import React, { useState, useEffect } from "react";
import { withRouter } from "react-router";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import styled from "styled-components";
import axios from "react-axios";

import { useUser } from "~/Context/userContext";
import MessageBoardTopic from "./MessageBoardTopic";
import { postMessageBoardReply } from "~/api/getMessageBoard";

export const Wrapper = styled.section``;

function MessageBoardNewPage({ history, props }) {
  const { state: userState } = useUser();
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(true);
  const [preview, setPreview] = useState(false);
  const [error, setError] = useState(false);
  const [formValid, setFormValid] = useState();

  const [isChimney, setIsChimney] = useState(false);
  const [isUser, setIsUser] = useState(false);
  const [username, setUsername] = useState(null);
  const [userDir, setUserDir] = useState(null);
  const [subject, setSubject] = useState("");
  const [comment, setComment] = useState("");

  useEffect(() => {
    const isChim = !!(userState.loggedin && userState.isChim);
    const isUser = !!(userState.loggedin && !userState.isChim);
    // console.log("isChim:", isChim);
    setIsChimney(isChim);
    setIsUser(isUser);
    setUserDir((userState.user && userState.user.dir) || null);
  }, [userState]);

  useEffect(() => {
    const hasSubject = !!(subject && subject.trim() !== "");
    const hasComment = !!(comment && comment.trim() !== "");
    const hasUsername = !!(username && username.trim() !== "");
    const hasName = !userState.loggedin ? hasUsername : true;
    setFormValid(hasSubject && hasComment && hasName);
  }, [subject, comment, username]);

  // sets the preview message only
  const [topic, setTopic] = useState({
    subject: "",
    date: "Now",
    comment: "",
    thread_author: {
      dir: null,
      full_name: "",
      user_type: "anon",
    },
  });

  useEffect(() => {
    setLoading(!userState.loaded);
  }, [userState.loaded]);

  const handlePreview = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setPreview(true);

    const full_name = userState.loggedin ? userState.user.full_name : username;
    const user_type = isChimney ? "chim" : isUser ? "user" : "anon";
    const authorDir = userDir;

    const author = { ...topic.thread_author, user_type, full_name, dir: authorDir };
    console.log("author:", author);

    setTopic({ ...topic, subject, comment, thread_author: { ...author } });

    setTimeout(function () {
      window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
    }, 120);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (!subject || !comment) return null;

    setSubmitting(true);

    const author = userState.loggedin ? `${userState.user.dir}loggedin` : username;

    const payload = { subject, comment, author };

    const response = await postMessageBoardReply(axios, payload);
    if (response.data && response.data.thread_id) {
      history.push(`/message-board/topic/${response.data.thread_id}`);
    } else {
      setSubmitting(false);
      setError(true);
    }
  };

  return (
    <Wrapper>
      <Row>
        <Col xs={12} md={{ span: 8, offset: 2 }} className="">
          <div className="totd-featured-box">
            <Form className="mb-search-form" noValidate>
              <Form.Group>
                <h2>
                  <FontAwesomeIcon icon="comments" className="comments" /> Create a Message Board post
                </h2>
                <p>Start a new topic about whatever you are into at the moment.</p>

                {!loading && !userState.loggedin && (
                  <Form.Group as={Row}>
                    <Form.Label column sm={12}>
                      Your Name
                    </Form.Label>
                    <Col md={6}>
                      <Form.Control onChange={(e) => setUsername(e.target.value.trim())} id="name" type="text" autoComplete="off" />
                    </Col>
                  </Form.Group>
                )}

                <Form.Group as={Row}>
                  <Form.Label column sm={12}>
                    Subject
                  </Form.Label>
                  <Col md={8}>
                    <Form.Control onChange={(e) => setSubject(e.target.value.trim())} id="subject" type="text" autoComplete="off" />
                  </Col>
                </Form.Group>

                <Form.Group as={Row}>
                  <Form.Label column sm={12}>
                    Message
                  </Form.Label>
                  <Col xs={12} md={10}>
                    <Form.Control onChange={(e) => setComment(e.target.value.trim())} id="comment" as="textarea" rows="6" />
                  </Col>
                </Form.Group>
                {!loading && !submitting && (
                  <Button onClick={handlePreview} variant="secondary" id="btn-preview" type="submit">
                    Preview
                  </Button>
                )}
                {preview && !submitting && formValid && (
                  <Button onClick={handleSubmit} variant="primary" id="btn-submit" type="submit" style={{ marginLeft: "40px" }}>
                    Submit
                  </Button>
                )}
                {submitting && <div>Submitting... please hold.</div>}
                {error && (
                  <div className="totd-featured-box">
                    <p>There was an unknown error. Copy your message, reload the page and try again.</p>
                  </div>
                )}
              </Form.Group>
            </Form>
          </div>
        </Col>
      </Row>
      {preview && (
        <Row>
          <Col xs={12} md={{ span: 8, offset: 2 }} className="">
            <center>
              <h2>* Preview *</h2>
            </center>
            <MessageBoardTopic preview topic={topic} loading={false} />
          </Col>
        </Row>
      )}
    </Wrapper>
  );
}

export default withRouter(MessageBoardNewPage);
